'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  color: ', ';\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n  margin: 3px;\n  padding: 6px 0px;\n  border-radius: 12px;\n  width: 85px;\n  min-width: 85px;\n  max-width: 85px;\n  text-align: center;\n  opacity: ', ';\n  pointer-events: ', ';\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  background: ', ';\n  color: ', ';\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n  margin: 3px;\n  padding: 6px 0px;\n  border-radius: 12px;\n  width: 85px;\n  min-width: 85px;\n  max-width: 85px;\n  text-align: center;\n  opacity: ', ';\n  pointer-events: ', ';\n\n  &:hover {\n    background: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Row = _styledComponents2.default.div(_templateObject, function (_ref) {
  var selected = _ref.selected;
  return selected ? _colors.red : _colors.grey;
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? _colors.white : _colors.darkGrey;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 0.3 : 1;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'none' : 'auto';
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected ? _colors.red : _colors.grey;
});

exports.default = Row;